import React, { useEffect } from "react";
import Hero from "./components/Hero";
import Screenshots from "./components/Screenshots";
import "./index.css";

const App = () => {
  useEffect(() => {
    document.title = "Bookseed - Short Book Summaries"; // Change tab title
  }, []);
  return (
    <div className="min-h-screen animated-bg">
      <Hero />
      <Screenshots />
      {/* <Features />
      <footer className="text-center text-white py-6">
        <p>Developed by <span className="text-yellow-400">Bhavya Vishnani</span></p>
      </footer> */}
    </div>
  );
};

export default App;
